type WhiteLabelType = 'abnk' | 'ghl';

type ColorType = {
  primary: string;
  secondary: string;
  tertiary: string;
};

const COLORS: Record<WhiteLabelType, ColorType> = {
  abnk: {
    primary: '#2da04e',
    secondary: '#31af55',
    tertiary: '#31af55',
  },
  ghl: {
    primary: '#299448',
    secondary: '',
    tertiary: '',
  },
};

// TODO: Currently default to ABNK.
const WHITE_LABEL: WhiteLabelType = 'abnk';

const Styles = {
  colors: {
    ...COLORS[WHITE_LABEL],
    background: '#F6F6F6',
    overlay: '#000000A1',
    white: '#FFFFFF',
    disabled: '#D9D9D9',
    tangerine: '#FF761C',
    error: '#FF4A4A',
    warningRed: {
      faint: '#FDE4E1',
      normal: '#FF6161',
      strong: '#C74141',
    },
    green: {
      faint: '#CEF2EA',
      normal: '#4CD964',
      strong: '#0AC094',
    },
    gray: {
      faint: '#E9E9E9',
      light: '#D9D9D9',
      normal: '#6F6F70',
      strong: '#7F7F7F',
    },
    black: {
      light: '#181818',
    },
  },
};

export default Styles;
